// index.jsx - FIXED

import React from "react";
import { createRoot } from "react-dom/client";
// 🚨 NEW: Import HelmetProvider
import { HelmetProvider } from "react-helmet-async"; 
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const container = document.getElementById("root");
const root = createRoot(container);

// 🚀 SOLID FIX: Wrap the entire application with HelmetProvider
// This provides the context (the internal 'dispatcher') that <Helmet> needs.
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Note: Added <React.StrictMode> for best practice development checks.